import React from 'react';

export const EventUI: React.FC = (): JSX.Element => {
  return (
    <section className="w-full">
      <div className="container w-full md:max-w-[1110px] mx-auto flex flex-col items-center">
        <div className="p-8 md:flex-shrink-0">
          <div className="text-[#013209] font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-center dark:text-white ">
            Eventos
          </div>
        </div>
      </div>
    </section>
  );
};
